import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';

// Column
import { CollegeManagementColumns } from '../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, statusFilterOptions } from '../../appconfig/Settings';

//Services
import { deleteData, getAllDetails, postAllData } from '../../service/ProductService';
//breadcrumb
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';

import { imageTemplate } from '../../appconfig/DatatableTemplateSetting';

import { Buffer } from 'buffer';

// Api
import { COLLEGE_DELETE, COLLEGE_EDIT, COLLEGE_LIST, COLLEGE_LOGIN_APPROVE, COLLEGE_REGISTER, GET_COLLEGES } from '../../config/ApiConstant';
import { addUpdateCollegeValidate } from '../../config/Validate';
import { CollegeManageTab } from './CollegeManageTab';
import { InputSwitch } from 'primereact/inputswitch';
import { Badge } from 'primereact/badge';

export const CollegeManagement = () => {
    document.title = 'College Management | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [collegeList, setCollegeList] = useState<any>([]);
    const [colleges, setColleges] = useState<any>([]);
    const [editId, setEditId] = useState<any>(null);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [collegeDetails, setCollegeDetails] = useState<any>({});
    const [principalSign, setPrincipalSign] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [statusValue, setStatusValue] = useState<any>(null);

    // use effect method
    useEffect(() => {
        getColleges();
        getCollegeList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get all colleges for dropdown
    const getColleges = async () => {
        try {
            const response = await getAllDetails(GET_COLLEGES + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setColleges([]);
                } else {
                    let collegeData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const collegeObj: any = {};
                        collegeObj['name'] = DataList[i].orgnameeng;
                        collegeObj['code'] = DataList[i].orgcode;
                        collegeData.push(collegeObj);
                    }
                    setColleges(collegeData);
                }
            } else {
                setColleges([]);
            }
        } catch (error: any) {
            setColleges([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get college list api call
    const getCollegeList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(COLLEGE_LIST);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCollegeList([]);
                } else {
                    setCollegeList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setCollegeList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setCollegeList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
        getCollegeList();
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <Button label="Add College" icon="pi pi-plus" className="p-button mr-2" onClick={() => openAddModal()} />
            </>
        );
    };

    //clear button
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary mr-2"></Button>
            </>
        );
    };

    // Template for action body
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="flex">
                    {/* <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} /> */}
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData.id)} />
                </div>
            </>
        );
    };

    // Template for college name
    const collegeNameTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div>
                    <Button tooltip={rowData?.full_name} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                        <div className="college-name-div">{rowData?.full_name}</div>
                    </Button>
                </div>
            </>
        );
    };

    // PCI Code Template
    const pciCodeTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div>
                        <div className="college-name-div">{!window.cn(rowData?.pci_college_code) ? rowData?.pci_college_code : "-"}</div>
                </div>
            </>
        );
    };

    // Image Template
    const imageProofTemplate = (rowdata: any, imgUrl: any) => {
        return (
            <>
                {!window.cn(rowdata) && !window.cn(rowdata[imgUrl.field]) ? (
                    <div className="main-img-box">
                        <img src={rowdata[imgUrl.field]} className="img-fluid" alt="main-img" />
                    </div>
                ) : "-"}
            </>
        );
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setCollegeDetails({});
        setErrors({});
        setEditId(null);
        setSubmitLoading(false);
        setAddUpdateModal(false);
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setEditId(rowData.id);

        const fileName = rowData.principal_sign.split('/').pop();
        const fileType = `${fileName.split('.').pop()}`;
        // Create the desired object
        const FileObject = {
            url: rowData.principal_sign,
            name: fileName,
            type: fileType
        };
        setCollegeDetails({
            college: { name: rowData.full_name, code: rowData.college },
            principal_name: rowData.principal_name,
            email: rowData.email,
            mobile: rowData.mobile,
            principal_signimg: FileObject
        });
        setAddUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setSubmitLoading(false);
        setDeleteModal(false);
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'college') {
            val = e;
        } else if (name === 'principal_signimg') {
            val = e.target.files[0] || '';
        } else {
            val = (e.target && e.target.value) || '';
        }
        setCollegeDetails({ ...collegeDetails, [name]: val });
    };

    // On submit add update college
    const onSubmitAddUpdateCollege = async () => {
        try {
            const { errors, isError } = addUpdateCollegeValidate(collegeDetails, principalSign, editId);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                //Request object
                let formData: any = new FormData();

                // Check editing is performed or not
                let apiSlug = COLLEGE_REGISTER;
                if (editId !== null) {
                    apiSlug = COLLEGE_EDIT;
                    formData.append('id', editId);

                    if (collegeDetails?.principal_signimg && collegeDetails?.principal_signimg.name && !collegeDetails?.principal_signimg.url) {
                        formData.append('principal_signimg', collegeDetails?.principal_signimg);
                    }
                } else {
                    // Check for image if uploaded or not
                    if (!window.cn(collegeDetails) && !window.cn(collegeDetails.principal_signimg)) {
                        formData.append('principal_signimg', collegeDetails?.principal_signimg);
                    }
                }

                // Add user type college
                formData.append('user_type', 'College');

                // Add other data in formdata
                for (let key in collegeDetails) {
                    if (key !== 'principal_signimg') {
                        if (key === 'college') {
                            formData.append('full_name', collegeDetails[key]?.name);
                            formData.append('college', collegeDetails[key]?.code);
                        } else if (key === 'password') {
                            let passwordBuff = Buffer.from(collegeDetails[key]).toString('base64');
                            formData.append('password', passwordBuff);
                        } else {
                            formData.append(key, collegeDetails[key]);
                        }
                    }
                }

                //apicall
                const response = await postAllData(apiSlug, formData);
                if (response && !window.cn(response)) {
                    setEditId(null);
                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    closeAddUpdateModal();
                    setTimeout(() => {
                        getCollegeList();
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                const backendErrors = error.response.data.errors;

                if (backendErrors) {
                    // Map backend errors to your state
                    const formattedErrors: any = {};

                    Object.keys(backendErrors).forEach((key) => {
                        formattedErrors[key] = backendErrors[key].join(' '); // Convert array messages into a single string
                    });
                    setErrors(formattedErrors);
                    setSubmitLoading(false);

                    toast.current?.show({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: 'Please fix the errors and try again.'
                    });
                } else {
                    //Spinner False and Set Toast

                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Alert', detail: error.response.data.error || 'Something went wrong!' });
                }
            }
        }
    };

    // Approve/disapprove handler
    const handleStatusChange = (row: any, newValue: boolean) => {
        confirmDialog({
            header: 'Confirm',
            message: `Are you sure you want to ${newValue ? 'approve' : 'Pending'} this record?`,
            acceptClassName: 'p-button-success',
            rejectClassName: 'p-button-secondary',
            accept: async () => {
                try {
                    const res = await getAllDetails(`${COLLEGE_LOGIN_APPROVE}?id=${row.id}`);
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'College has been approved'
                    });
                    getCollegeList();
                } catch {
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Status update failed'
                    });
                }
            }
        });
    };

    // Delete college api call
    const deleteCollegeApiCall = async () => {
        try {
            setSubmitLoading(true);
            // Delete api call
            const response = await deleteData(COLLEGE_DELETE, deleteId);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setSubmitLoading(false);
                setDeleteModal(false);
                setDeleteId(null);
                getCollegeList();
                setPageLoad(true);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setSubmitLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setSubmitLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    //delete selected file
    const onFileDelete = (name: string) => {
        setCollegeDetails({ ...collegeDetails, [name]: '' });
    };

    // status template
    const statusTemplate = (row: any) => {
        const approved = Number(row.is_approved) === 1;
        return (
            <div className="flex flex-column align-items-center">
                <InputSwitch checked={approved} className="mb-2" disabled={approved} onChange={(e) => handleStatusChange(row, e.value)} />
                <Badge value={approved ? 'Approved' : 'Pending'} severity={approved ? 'success' : 'warning'} />
            </div>
        );
    };

    // status filter template
    const statusFilterTemplate = (options: any) => {
        return (
            <Dropdown
                filter
                value={statusValue}
                options={statusFilterOptions}
                onChange={(e) => {
                    setStatusValue(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                placeholder="Filter by status"
                className="p-column-filter"
                optionLabel="name"
                showClear
            />
        );
    };

    return (
        <>
            <CollegeManageTab mainTabLabel="College Management" />
            <Toast ref={toast} />
            <ConfirmDialog draggable={false} />
            <AppBreadcrumb currentMenu={'College Management'} pageName={'College Management'} pageTitle={'College Management'} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={collegeList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={collegeList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Colleges Found"
                                    removableSort
                                >
                                    {CollegeManagementColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'email') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'mobile') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'principal_sign') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={imageProofTemplate} />;
                                        } else if (col.field === 'proof_of_college') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={imageProofTemplate} />;
                                        } else if (col.field === 'full_name') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={collegeNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'pci_college_code') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={pciCodeTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                        } else if (col.field === 'is_approved') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={statusFilterTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {CollegeManagementColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '74vw' }}
                header={editId !== null ? 'Edit College Details' : 'Add College'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" className="p-button-primary" icon="pi pi-check" onClick={() => onSubmitAddUpdateCollege()} loading={submitLoading} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="name">
                            College Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={collegeDetails?.college}
                            name="college"
                            options={colleges}
                            filter
                            optionLabel="name"
                            placeholder="Select College"
                            onChange={(e) => onInputChange(e.value, 'college')}
                            className={errors['college'] && 'p-invalid'}
                            disabled={editId !== null ? true : false}
                        />
                        <small className="p-invalid-txt">{errors['college']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Email <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={collegeDetails?.email} name="email" autoComplete="off" placeholder="Enter Email" onChange={(e) => onInputChange(e, 'email')} className={errors['email'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['email']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Principal Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText
                            value={collegeDetails?.principal_name}
                            name="principal_name"
                            autoComplete="off"
                            placeholder="Enter Principal Name"
                            onChange={(e) => onInputChange(e, 'principal_name')}
                            className={errors['principal_name'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['principal_name']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Mobile No. <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText keyfilter="num" value={collegeDetails?.mobile} name="mobile" onChange={(e) => onInputChange(e, 'mobile')} id="mobile" className={errors['mobile'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['mobile']}</small>
                    </div>
                    {editId === null ? (
                        <div className="field col-6">
                            <label htmlFor="name">
                                Password <span style={{ color: 'red' }}>*</span>
                            </label>
                            <InputText type="password" value={collegeDetails?.password} name="password" autoComplete="off" placeholder="Enter Password" onChange={(e) => onInputChange(e, 'password')} className={errors['password'] && 'p-invalid'} />
                            <small className="p-invalid-txt">{errors['password']}</small>
                        </div>
                    ) : (
                        <>
                            <div className="field col-6"></div>
                        </>
                    )}
                    <div className="field col-6">
                        <label htmlFor="name">Add Signature </label>
                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i>
                            <span>Upload Signature</span>
                            <input type="file" id="fileInput" accept="image/png, image/jpeg , image/jpg" onChange={(e) => onInputChange(e, 'principal_signimg')} className="file-input" />
                        </div>

                        {window.cn(editId) && !window.cn(collegeDetails?.principal_signimg) && (
                            <div className="file-preview">
                                <div className="file-info">
                                    <a href={URL.createObjectURL(collegeDetails.principal_signimg)} target="_blank" rel="noopener noreferrer" className="file-name">
                                        {collegeDetails.principal_signimg.name}
                                    </a>
                                    <span className="file-details">
                                        {collegeDetails?.principal_signimg.type} &nbsp;♦&nbsp; {(collegeDetails?.principal_signimg.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                                <i className="pi pi-trash file-delete" onClick={() => onFileDelete('principal_signimg')} title="Delete"></i>
                            </div>
                        )}

                        {!window.cn(editId) && !window.cn(collegeDetails)
                            ? (!window.cn(collegeDetails?.principal_signimg) || collegeDetails?.principal_signimg?.name) && (
                                <>
                                    <div className="file-preview">
                                        <div className="file-info">
                                            <a
                                                href={!window.cn(collegeDetails?.principal_signimg) ? collegeDetails?.principal_signimg : URL.createObjectURL(collegeDetails?.principal_signimg)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="file-name"
                                            >
                                                {collegeDetails?.principal_signimg?.name}
                                            </a>
                                            <span className="file-details">
                                                {collegeDetails?.principal_signimg.type} &nbsp;&nbsp; {!window.cn(collegeDetails?.principal_signimg.size) && (collegeDetails?.principal_signimg.size / 1024).toFixed(2) + ' ' + 'KB'}
                                            </span>
                                        </div>
                                        {!collegeDetails?.principal_signimg.size?.url && <i className="pi pi-trash file-delete" onClick={() => onFileDelete('principal_signimg')} title="Delete"></i>}
                                    </div>
                                </>
                            )
                            : ''}
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete College"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteCollegeApiCall} loading={submitLoading} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this College, This will be deleted permanently.</span>
                </div>
            </Dialog>
        </>
    );
};
